// extracted by mini-css-extract-plugin
export default {"modalContainer":"MiniCartModal_modalContainer__a+ldZ","slideInFromTop":"MiniCartModal_slideInFromTop__YgtLO","emptyCart":"MiniCartModal_emptyCart__nK1fr"};